import React from "react"
import { Button, Card, Container, Input, Form, FormField } from "semantic-ui-react";
import shop from "shop/shop"
import Price from "../../components/Price/Price";
import _ from "lodash"
import { Link } from "react-router-dom";
import moment from "moment"

function uuid() {
  let firstPart = (Math.random() * 46656) | 0;
  let secondPart = (Math.random() * 46656) | 0;
  firstPart = ("000" + firstPart.toString( 36 )).slice( -3 );
  secondPart = ("000" + secondPart.toString( 36 )).slice( -3 );
  return firstPart + secondPart;
}


export default function MerklistePage() {
  return <div className="MerklistePage">
    
    <Container className="pb5 pt3">
      <h1 className="page-title">Merkliste</h1>
      
      <div>
        <CreateList onSubmit={async ( listName ) => {
          const listId = `list-${uuid()}`
          await shop.store.server.post( `list-${listId}`, {
            id      : listId,
            type    : "list",
            name    : listName,
            products: [],
            extra   : {},
            created : moment().toISOString(),
            sum     : 0
          } )
        }}/>
      </div>
      
      
      <div>
        <ServerStore/>
      </div>
    
    </Container>
  </div>
}

function ServerStore( { name = "" } ) {
  const [data, setData] = React.useState( false )
  const [lists, setLists] = React.useState( [] )
  
  React.useEffect( () => {
      if ( data ) return
      shop.store.server.get( name )
        .then( data => {
          console.log("SAVE", data )
          let lists = _.map( data, ( entry, key ) => entry ).filter( e => e.type === "list" )
          setLists( lists )
          setData( data )
        } )
    }
    , [name] )
  
  return <div>
    <Card.Group>
    
    </Card.Group>
    {lists.map( list => {
      console.log( { list } )
      return <Card key={list.id} as={Link} to={`/list/${list.id}/`}>
        <Card.Content>
          <div className={"f6 black-60"}>{translate( "Merkliste" )}</div>
          <div>{list.name}</div>
          <div className="pt2 b"><Price showZero>{list.sum}</Price></div>
          <div><span className="b black">{list.products.length}</span> {translate( list.products.length === 1 ? "Produkt" : "Produkte" )}</div>
        </Card.Content>
        <Card.Content>
          <div className="flex flex-row justify-between">
            <Button size="tiny">Standard</Button>
          </div>
        </Card.Content>
      </Card>
    } )}
    <pre>{JSON.stringify( data, null, 2 )}</pre>
  </div>
}


class CreateList extends React.Component {
  
  state = { name: "" }
  
  handleChange = ( e ) => {
    this.setState( { name: e.target.value } )
  }
  
  render() {
    const { onSubmit } = this.props
    return (
      <Form
        className="pb2"
        onSubmit={( e ) => {
          if ( this.state.name.length >= 3 ) {
            onSubmit( this.state.name )
          } else {
            shop.toast( translate( "Der Merklisten-Titel sollte mindestens 3 Zeichen beinhalten" ), "warning" )
          }
          e.preventDefault()
        }}>
        <FormField label={<span className="dib pr2">{translate( "create new orderlist" )}</span>}
                   htmlFor="supported-controls-input">
          <Input
            id="newListName"
            onChange={this.handleChange}
            name="supported-controls-input"
            action={<Button>{translate( "create" )} </Button>} placeholder="name"/>
        </FormField>
      </Form>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/merkliste/MerklistePage.js